module.exports = __webpack_public_path__ + "static/media/play.3c440e89.svg";